export const shifathLockupPrimaryUrl = new URL("./assets/shifath-lockup-primary.svg", import.meta.url).href;
export const shifathLockupDarkUrl = new URL("./assets/shifath-lockup-dark.svg", import.meta.url).href;
export const shifathMarkPrimaryUrl = new URL("./assets/shifath-mark-primary.svg", import.meta.url).href;
